import { RefObject, useEffect, useState } from "react";
import { Bounds, useGesture, Vector2 } from "@use-gesture/react";
import { ImageClickPosition } from "../utils/utils";

const initialDrag: Vector2 = [0, 0];
const initialBounds = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
};

export const recalculateBoundaries = (
  imageRef: RefObject<HTMLImageElement | null>,
) => {
  if (!imageRef.current) {
    return initialBounds;
  }

  const windowHeight = window.innerHeight;
  const windowWidth = window.innerWidth;

  const { width: imageWidth, height: imageHeight } =
    imageRef.current.getBoundingClientRect();

  if (imageWidth > windowWidth) {
    return {
      top: windowHeight - imageHeight,
      bottom: 0,
      left: windowWidth - imageWidth,
      right: 0,
    };
  }

  return initialBounds;
};

export const useGalleryGesture = (
  imageRef: RefObject<HTMLImageElement | null>,
): [Vector2, (clickPosition: ImageClickPosition) => void] => {
  const [drag, setDrag] = useState<Vector2>(initialDrag);
  const [bounds, setBounds] = useState<Bounds>(initialBounds);

  const resetAdjustments = (imageClickPosition: ImageClickPosition) => {
    const bounds = recalculateBoundaries(imageRef);
    const xDrag =
      imageClickPosition.x * -1 < bounds.left
        ? bounds.left
        : imageClickPosition.x * -1;
    const yDrag =
      imageClickPosition.y * -1 < bounds.top
        ? bounds.top
        : imageClickPosition.y * -1;
    setDrag([xDrag, yDrag]);
    setBounds(bounds);
  };

  useGesture(
    {
      onDrag: ({ offset: [dx, dy], pinching, cancel }) => {
        if (pinching) {
          return cancel();
        }

        setDrag([dx, dy]);
      },
    },
    {
      drag: {
        bounds,
        from: drag,
      },
      target: imageRef,
    },
  );

  return [drag, resetAdjustments];
};
